import { format } from 'date-fns';
import React, { FunctionComponent } from 'react';

export const PostDate: FunctionComponent<{
  date: Date;
}> = ({ date }) => {
  return <>{format(date, 'PP')}</>;
};
